import React from "react";
import { Router, Route } from "react-router-dom";
import { connect } from "react-redux";
import { history } from "../_helpers";
import { PrivateRoute } from "../_components";
import { LoginPage } from "../LoginPage";
import { StudentLogin } from "../StudentLogin";
import { StudentPage } from "../StudentPage";
import { StudentSignUp } from "../StudentSignUp";
import { ChallengesPage } from "../HomePage/ChallengesPage";
import QuizPage from "../HomePage/QuizPage";
import UploadResult from "../HomePage/UploadResult";
import UploadStudent from "../HomePage/UploadStudent";
import { StudentEmailVerify } from "../StudentEmailVerify";
import { ResetPassword } from "../StudentLogin/ResetPassword";
import { SendCode } from "../StudentLogin/SendCode";

class App extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <div className="col-lg-12 p-0">
          <Router history={history}>
            <div>
              {/*<PrivateRoute exact path="/admin" component={HomePage} />*/}
              <Route exact path="/admin/login" component={LoginPage} />
              <Route exact path="/" component={StudentLogin} />
              <Route exact path="/result" component={StudentPage} />
              <Route exact path="/signUp" component={StudentSignUp} />
              <Route path="/verifyEmail" component={StudentEmailVerify} />
              <Route exact path="/student/emailVerify" component={StudentEmailVerify} />
              <Route exact path="/login/resetPassword" component={ResetPassword} />
              <Route exact path="/login/sendCode" component={SendCode} />
              <PrivateRoute exact path="/admin/challenges" component={ChallengesPage} />
              <PrivateRoute exact path="/admin/quizzes" component={QuizPage} />
              <PrivateRoute exact path="/admin/students" component={UploadStudent} />
              <PrivateRoute exact path="/admin/result" component={UploadResult} />
            </div>
          </Router>
        </div>
      </div>
    );
  }
}

const connectedApp = connect()(App);
export { connectedApp as App };
